import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CommonService }  from '../../service/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'expediusa-shared-element-logo-carousel',
    templateUrl: './logo_carousel.component.html',
	styleUrls : ['./logo_carousel.component.css'],
	providers: []
	
})

  
export class LogoCarouselComponent implements OnInit, OnDestroy {

	/**This is used to prevent memory leaks **/
	private ngUnsubscribe: Subject<void> = new Subject<void>();
	/**This is used to prevent memory leaks **/

	env	=	environment;
    logoData : any = [];
    imagePath : any = '';
    customOptions: OwlOptions = {
		loop:false,
        autoplay:true,
        margin:15,
        nav:false,
        dots:false,
        autoWidth:true,
		responsive:{
			0:{
                items:2
            },
            479:{
                items:3
            },
            768:{
                items:4
            },
            992:{
                items:6
            },
            1200:{
                items:12
            }
		}		
	}

    // Declare Constructor
	constructor(private commonService : CommonService) {}

    // Declare initialization
	ngOnInit(): void  {
        /**this funcation is used to get feature company logo */        
		this.getLogoData();
        /**this funcation is used to get feature company logo */        
    }
	
    /**this funcation is used to get feature caompany logo */
    public getLogoData(){
		this.commonService.getLogo().pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
            if (response.status === this.env.SUCCESS_STATUS) {
				this.logoData = response.result;
                this.imagePath = response.image_path;
			}
		});
	}
    /**this funcation is used to get feature caompany logo */

	/**This function are used for destroy the data**/
	ngOnDestroy(): void {
		this.ngUnsubscribe.next();
	}
	/**This function are used for destroy the data**/

}
